import React, { useState, useEffect } from "react";
import { useFlexSearch } from "react-use-flexsearch";
import S from "./Search.styled";
import SearchIcon from "@/assets/search.svg";
import { graphql, useStaticQuery } from "gatsby";
import Tag from "@/components/global-components/Tag";
import CloseIcon from "@/assets/close.svg";

type IResult = {
  title: string;
  uri: string;
  databaseId: number;
  date?: string;
  eventsInfo?: {
    contentTitle: string;
    ingress: string;
    wysiwygContent: string;
    tag: string;
  };
  newsInfo?: {
    contentTitle: string;
    ingress: string;
    wysiwygContent: string;
    tag: string;
  };
};

const Search = () => {
  const [searchOpen, setSearchOpen] = React.useState<boolean>(false);
  const [query, setQuery] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [searchResult, setSearchResult] = useState<IResult[]>([]);

  const data = useStaticQuery(graphql`
    {
      localSearchPages {
        index
        store
      }
    }
  `);

  const { index, store } = data.localSearchPages;
  const results = useFlexSearch(query, index, store);

  useEffect(() => {
    if (!searchOpen) {
      setSearchActive(false);
      setQuery("");
    }
  }, [searchOpen]);

  useEffect(() => {
    setSearchResult(results);
  }, [query]);

  useEffect(() => {
    searchResult.length > 0 && setSearchActive(true);
  }, [searchResult]);

  return (
    <>
      <meta
        name="search-results"
        content="width=device-width, initial-scale=1, maximum-scale=5"
      />
      <S.Search onClick={() => setSearchOpen(!searchOpen)}>
        Sök{" "}
        {searchOpen ? (
          <CloseIcon aria-label="Stäng sök" />
        ) : (
          <SearchIcon aria-label="Öppna sök" />
        )}
      </S.Search>

      <S.SearchContainer $searchOpen={searchOpen}>
        <S.FlexWrapper>
          <S.SearchMobile
            onClick={() => setSearchOpen(!searchOpen)}
            $searchOpen={searchOpen}
          >
            <SearchIcon aria-label="search" />
            <span className="searchText">Sök</span>
          </S.SearchMobile>
          <S.SearchInput
            onChange={(e: any) => setQuery(e.target.value)}
            value={query}
            type="text"
            name="search"
            placeholder="Ange sökterm.."
          />
        </S.FlexWrapper>
        <S.SearchBarWrapper $active={searchActive}>
          <S.DetailsWrapper>
            <S.DetailsText>Sökresultat</S.DetailsText>
            <S.DetailsText>{searchResult.length} träffar</S.DetailsText>
          </S.DetailsWrapper>
          <S.SearchResults $active={searchActive} $data={[]}>
            {searchResult.length === 0 && (
              <S.ResultText>Inga resultat hittades</S.ResultText>
            )}
            {searchResult.length > 0 &&
              searchResult?.map((result: IResult, index: number) => (
                <S.SearchItem key={index}>
                  <S.ResultCard href={result.uri}>
                    <S.ResultTitleWrapper>
                      {result.title && (
                        <S.ResultTitle>{result.title}</S.ResultTitle>
                      )}
                      <S.ResultInfo>
                        {result.date && (
                          <S.ResultDate>{result.date}</S.ResultDate>
                        )}
                        {result.eventsInfo?.tag && (
                          <Tag tag={result.eventsInfo.tag} />
                        )}
                        {result.newsInfo?.tag && (
                          <Tag tag={result.newsInfo.tag} />
                        )}
                      </S.ResultInfo>
                    </S.ResultTitleWrapper>
                    {result.eventsInfo?.wysiwygContent && (
                      <S.ResultText
                        dangerouslySetInnerHTML={{
                          __html: result.eventsInfo?.wysiwygContent || "",
                        }}
                      />
                    )}
                    {result.newsInfo?.wysiwygContent && (
                      <S.ResultText
                        dangerouslySetInnerHTML={{
                          __html: result.newsInfo?.wysiwygContent || "",
                        }}
                      />
                    )}
                  </S.ResultCard>
                </S.SearchItem>
              ))}
          </S.SearchResults>
        </S.SearchBarWrapper>
        <S.Overlay
          $searchOpen={searchActive}
          onClick={() => setSearchOpen(false)}
        />
      </S.SearchContainer>
    </>
  );
};

export default Search;
